import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import PaySlipSc from "./index.sc";
import { useRef } from "react";
import jsPDF from "jspdf";
import insytix from "../../Assets/insytix_logo.png";
import { useLocation, useParams } from "react-router-dom";
import { getIndEmployeePay } from "../../api/Payslip/getIndividulaEmployeePay";
import { useAuthContext } from "../../hooks";
import { getOrgUserDetails } from "../../api/users/getOrgUserDetails";
function Index() {
  const [show, setShow] = useState(false);
  const formRef = useRef<any>(null);
  const handleGeneratePdf = () => {
    const doc = new jsPDF({
      format: "a3",
      unit: "px",
    });

    // Adding the fonts
    doc.setFont("Inter-Regular", "normal");

    doc.html(formRef.current, {
      async callback(doc) {
        await doc.save("document");
      },
    });
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const auth = useAuthContext()
  const params = useParams()
  const location  = useLocation()
  console.log(location?.search.split("=")[1].split("&")[0])
  const [indPay,setIndPay] = useState<any>([])
  const [user, setUser] = useState<any>([]);
const fetchOrgUser = async () => {
  setUser(
    await getOrgUserDetails(
      auth?.userInfo?.orgs[0]?.id,
      params?.employeeId
    )
  );
  console.log("works");
};
  const fetchIndividualPay =async () => {
    const res = await getIndEmployeePay(auth?.userInfo?.orgs[0]?.id,location?.search.split("=")[1].split("&")[0])
    setIndPay(res)
  }
  useEffect(() => {
    fetchIndividualPay()
    fetchOrgUser()
  }, [])
  
  return (
    <>
      <PaySlipSc ref={formRef}>
        <div className="headings">
          <div>
            <img src={insytix} style={{ width: "100px" }} />
          </div>
          <div>
            <div>4/96 Balaji Nagar, Sengottai Road,</div>
            <div>Panpozhi , Tenkasi - 627809</div>
          </div>
          <div></div>
        </div>
        <hr />
        <label>Payslip for the month of April 2023</label>
        <div className="summary">Employee Pay Summary</div>
        <div className="org-employee-details">
          <div className="employee-personal">
            <div className="employee-particulars">
              <div>Employee Name</div>
              <div>Designation</div>
              <div>Bank name</div>
              <div>Paid date</div>
            </div>
            <div className="account-details">
              <div style={{ fontWeight: "bold" }}>: {indPay?.[0]?.Name} </div>
              <div style={{ fontWeight: "bold" }}>: {user?.[0]?.role} </div>
              <div style={{ fontWeight: "bold" }}>: HDFC (Tenkasi)</div>
              <div style={{ fontWeight: "bold" }}>: {}</div>
            </div>
          </div>
          <div className="employee-additional-details">
            <div className="employee-details1">
              <div>Employee ID</div>
              <div>Date of joining</div>
              <div>Account Number </div>
            </div>
            <div className="employee-details2">
              <div style={{ fontWeight: "bold" }}>: {indPay?.[0]?.employee_id}</div>
              <div style={{ fontWeight: "bold" }}>: {indPay?.[0]?.doj}</div>
              <div style={{ fontWeight: "bold" }}>: {indPay?.[0]?.acc_no}</div>
            </div>
          </div>
        </div>
        <hr />
        {/* <table className="payslip-leave-detail">
          <tr>
            <th>Leave Details</th>
            <th>Taken </th>
            <th>Available</th>
          </tr>
          <tr>
            <td>PTO</td>
            <td>24</td>
            <td>30</td>
          </tr>
          <tr>
            <td>Floating Holiday</td>
            <td>25</td>
            <td>40</td>
          </tr>
        </table> */}
        <hr />
        <div className="earnings-container">
          <table className="payslip-leave-details">
            <tr>
              <th>Earnings</th>
              <th>Amount </th>
            </tr>
            <tr>
              <td>Basic Pay</td>
              <td>{indPay?.[0]?.basic_pay}</td>
            </tr>
            <tr>
              <td>VPR</td>
              <td>{Math.trunc(indPay?.[0]?.vpr)}</td>
            </tr>
            <tr style={{ backgroundColor: "#e7dcdc25" }}>
              <th>Total Earnings</th>
              <th>{Math.trunc(indPay?.[0]?.basic_pay +indPay?.[0]?.vpr) }</th>
            </tr>
          </table>
          <table className="payslip-leave-details">
            <tr>
              <th>Deductions</th>
              <th>Amount </th>
            </tr>
            <tr>
              <td>EPF</td>
              <td>{indPay?.[0]?.epf}</td>
            </tr>
            <tr>
              <td>ESI</td>
              {/* <td>{indPay?.[0]?.esi}</td> */}
              <td>-</td>
            </tr>
            <tr>
              <td>TAX</td>
              {/* <td>{indPay?.[0]?.tax}</td> */}
              <td>-</td>

            </tr>
            <tr style={{ backgroundColor: "#e7dcdc25" }}>
              <th>Total Deductions</th>
            
              {/* <th>{indPay?.[0]?.epf + indPay?.[0]?.tax + indPay?.[0]?.esi  }</th> */}
            <th>{indPay?.[0]?.epf}</th>
            </tr>
          </table>
        </div>

        <div className="net-pay">
          <div>
            {/* <label>Total Net Payable {indPay?.[0]?.net_pay}</label> */}
            <label>Total Net Payable {(indPay?.[0]?.basic_pay +indPay?.[0]?.vpr ) - indPay?.[0]?.epf }</label>
          </div>
          <div>
            (Toatal Net Payable = ((Gross Toatal Earings - Deductions)))
          </div>
        </div>
      </PaySlipSc>
    </>
  );
}
export default Index;
